<template>
  <div class="common-text-box-small mb-4">
    <div v-show="showTitle" class="flex items-center justify-start mb-2">
      <span class="mr-2">{{ title }}</span>
      <div v-show="required"><span class="required"> * </span></div>
    </div>
    <vs-input
      class="w-full"
      v-model="inputValue"
      :placeholder="placeholder"
      :danger="error"
      :disabled="isDisabled"
      :danger-text="dangerText"
    ></vs-input>
  </div>
</template>

<script>
export default {
  name: "M.CommonTextBoxSmall",
  props: {
    title: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    validate: {
      type: Function,
    },
    placeholder: {
      type: String,
      required: false,
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    dangerText: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      inputValue: "",
      error: false,
    };
  },
  watch: {
    inputValue(val) {
      if (!this.validate) {
        return;
      }
      const isValid = this.validate(val);
      this.error = !isValid;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

.common-text-box-small {
  .required {
    color: $aisea-red;
  }
}
</style>
